import { Validator } from '@vista-digital/validator';
/**
 * Default configuration options for the Film Watchlist Button component.
 */
export const defaultFilmWatchlistButtonConfig = {
    iconOnly: false
};
export const filmWatchlistButtonConfigValidatorSchema = {
    iconOnly: Validator.boolean()
};
export const filmWatchlistButtonConfigValidator = Validator.object(filmWatchlistButtonConfigValidatorSchema);
//# sourceMappingURL=config.js.map